export const NAME = 'adminV2.ownOrganization';

const initialState = {
    organization: {},
    users: [],
    isOrgLoading: true,
    isUsersLoading: true,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
        case 'ADMIN_V2__FETCH_OWN_ORGANIZATION_START': {
            // Clear display data so empty labels do not show under the loading overlay
            return {
                ...state,
                isOrgLoading: true,
                isUsersLoading: true,
                organization: {},
                users: [],
            };
        }
        case 'ADMIN_V2__FETCH_OWN_ORGANIZATION_END': {
            return {
                ...state,
                isOrgLoading: false,
                isUsersLoading: false,
                organization: action.payload.data.organization,
                users: action.payload.data.users,
            };
        }
        case 'ADMIN_V2__FILTER_USERS_START': {
            // Sync search — do not toggle isUsersLoading (avoids page spinner flash)
            return state;
        }
        case 'ADMIN_V2__FILTER_USERS_END': {
            return {
                ...state,
                users: action.payload.filteredUsers,
            };
        }
    }
}
